import {
  Text,
  Button,
  Spinner,
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogBody,
  useDisclosure,
  AlertDialogFooter,
  AlertDialogCloseButton,
} from '@chakra-ui/react';
import React, { useRef } from 'react';

import { colors } from 'packages/common-frontend/colors';

type VerificationReportTakeActionButtonProps = {
  pendingOperation:
    | 'reject'
    | 'approve'
    | 'requestRemediation'
    | 'notify'
    | 'none';
  onClickConfirmAction: () => Promise<void>;
  headerText: string;
  bodyText: string;
  confirmActionButtonText: string;
  mainActionButtonStyle: 'fill' | 'outline';
};
export const VerificationReportTakeActionButton = ({
  pendingOperation,
  onClickConfirmAction,
  headerText,
  bodyText,
  confirmActionButtonText,
  mainActionButtonStyle,
}: VerificationReportTakeActionButtonProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const cancelRef = useRef(null);
  return (
    <>
      <Button
        isDisabled={pendingOperation !== 'none'}
        borderColor={colors.aurora[900]}
        borderWidth="medium"
        color={mainActionButtonStyle === 'fill' ? 'white' : colors.aurora[900]}
        background={
          mainActionButtonStyle === 'fill' ? colors.aurora[900] : 'white'
        }
        onClick={onOpen}
      >
        {confirmActionButtonText}
      </Button>
      <AlertDialog
        leastDestructiveRef={cancelRef}
        isOpen={isOpen}
        onClose={onClose}
        size="lg"
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight={600}>
              {headerText}
            </AlertDialogHeader>
            <AlertDialogCloseButton />

            <AlertDialogBody>
              <Text mb="8px" color={colors.black[70]}>
                {bodyText}
              </Text>
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button
                isDisabled={pendingOperation !== 'none'}
                ref={cancelRef.current}
                onClick={onClose}
                mr="32px"
                colorScheme="aurora"
                variant="outline"
                borderWidth="2px"
              >
                Cancel
              </Button>
              <Button
                isDisabled={pendingOperation !== 'none'}
                borderColor={colors.aurora[900]}
                borderWidth="2px"
                colorScheme="aurora"
                onClick={onClickConfirmAction}
              >
                <Spinner
                  display={pendingOperation !== 'none' ? 'unset' : 'none'}
                  mr="12px"
                />
                {confirmActionButtonText}
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
};
